import { computed, signal, Signal } from '@angular/core';
import { sort } from '../sort/functions/sort.function';
import { Sort } from '../sort/types/sort';
import { ExplorerAddonFactory } from './explorer';

export interface SortExplorer<T> {
  sortParams: Signal<Sort<T> | null>;
  result: Signal<T[]>;
  sort(options: Sort<T> | null): void;
}

export interface SortExplorerOptions<T> {
  defaultSort?: Sort<T>;
}

export function withSort<T>(options?: SortExplorerOptions<T>): ExplorerAddonFactory<T, SortExplorer<T>> {
  return (source: Signal<T[]>): SortExplorer<T> => sortList<T>(source, options);
}

function sortList<T>(source: Signal<T[] | undefined>, options?: SortExplorerOptions<T>): SortExplorer<T>{
  const sortParams = signal<Sort<T> | null>(options?.defaultSort ?? null)
  return {
    sortParams,
    result: computed(() => {
      const items = source() ?? [];
      const params = sortParams();
      if(!params)
        return items;
      return sort(items, params);
    }),
    sort: (o) => sortParams.set(o),
  }
}
